import { render, staticRenderFns } from "./ModalBackofficeEditarProcedimentosAssociados.vue?vue&type=template&id=551e6cb4"
import script from "./ModalBackofficeEditarProcedimentosAssociados.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeEditarProcedimentosAssociados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports